export const NO_FULFILLMENT_CENTER = 'no_fc';

export const NO_FULFILLMENT_CENTER_ITEM = {
  uid: NO_FULFILLMENT_CENTER,
  name: 'No fulfillment center',
  is_shipping_option_supported: false,
  has_org_inventory: false,
};
